import {DataFieldWrapper} from '../../../core-entity/widgets/summary-widget/data-field-wrapper';
import {PeepTerritorySelectInline} from '../../../entity-details/peep-details/peep-territory-select-inline';

interface Props {
    territoryId: string | null | undefined;
    onUpdatePeepTerritory: (territoryId: string | null, territoryName: string | null) => void;
    canAccessSetup: boolean;
}

export function PeepTerritory(props: Props) {
    return (
        <DataFieldWrapper
            label='Territory'
            children={
                <PeepTerritorySelectInline
                    territoryId={props.territoryId}
                    onUpdatePeepTerritory={props.onUpdatePeepTerritory}
                    canAccessSetup={props.canAccessSetup}
                />
            }
        />
    );
}
